import ShieldIcon from "@mui/icons-material/Shield";
import { Avatar, Box, Chip, Paper, Stack, Typography } from "@mui/material";

import { EVOTRUX_GREEN } from "constants/index";

import { PhoneCard } from "./PhoneCard";

interface Props {
  phoneNumber: string;
}

export function MFAEnabledState(props: Props) {
  const { phoneNumber } = props;

  return (
    <Paper variant="outlined" sx={{ p: 3, mt: 2, bgcolor: "grey.50" }}>
      <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
        <Avatar
          sx={{
            bgcolor: "success.light",
            color: "success.dark",
            width: 40,
            height: 40,
          }}
        >
          <ShieldIcon />
        </Avatar>
        <Box>
          <Typography variant="subtitle1" fontWeight={500}>
            SMS Authentication
          </Typography>
          <Chip
            label="Enabled"
            color="success"
            size="small"
            variant="outlined"
          />
        </Box>
      </Stack>
      <Typography color="text.secondary" mb={2} maxWidth={560}>
        Your account is protected with SMS multi-factor authentication.
        Verification codes are sent to your registered phone number whenever you
        sign in.
      </Typography>
      <PhoneCard
        label="Registered Number"
        iconColor={EVOTRUX_GREEN}
        phoneNumber={phoneNumber}
        trailingNode={
          <Chip
            label="Active"
            size="small"
            sx={{
              bgcolor: "success.light",
              color: "success.dark",
              fontWeight: 500,
              fontSize: "0.7rem",
            }}
          />
        }
      />
    </Paper>
  );
}
